import { VisitGeneratorErrorCode } from './VisitGeneratorErrorCodes';

export class VisitGeneratorError extends Error {
  code: VisitGeneratorErrorCode;
  constructor(code: VisitGeneratorErrorCode, message?: string) {
    super(message);
    this.code = code;
  }
}
